import type { ThemeOptions } from "@mui/material";

const styleOverrides: Required<
  Required<ThemeOptions>["components"]
>["MuiCssBaseline"]["styleOverrides"] = {};

export const MuiCssBaseline: Required<
  Required<ThemeOptions>["components"]
>["MuiCssBaseline"] = { styleOverrides };
